import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

// components
import CardLogin from "components/Cards/Auth/CardLogin.js";
import FooterAuth from "components/Footers/Auth/FooterAuth.js";
// texts
import cardlogin from "_texts/auth/cards/cardlogin.js";
import footerauth from "_texts/auth/footers/footerauth.js";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "actions/users";
import { setIDToken, setActiveUser } from "utils/utils";

const Login = () => {
  const location = useLocation();
  const searchParams = useSearchParams();
  const activeUser = useSelector((state) => state.users.activeUser);
  const error = useSelector((state) => state.users.error);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchParams[0].get("logout")) {
      setIDToken(null);
      setActiveUser(null);
      dispatch(logoutUser());
      navigate("/login");
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (activeUser) {
      const redirectPath = localStorage.getItem("redirectPath");
      if (redirectPath) {
        localStorage.removeItem("redirectPath");
        navigate(redirectPath);
      } else {
        if (activeUser.user_type.match(/client/)) {
          navigate("/client");
        } else {
          navigate("/dashboard");
        }
      }
    }
  }, [activeUser, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-black bg-no-repeat bg-full"
            style={{
              backgroundImage:
                "url(" + require("assets/img/bg-agentwire2.png").default + ")",
            }}
          ></div>
          <div className="container mx-auto px-4 h-full">
            <div className="flex content-center items-center justify-center h-full">
              <div className="w-full lg:w-4/12 px-4">
                <CardLogin error={error} {...cardlogin} />
              </div>
            </div>
          </div>
          <FooterAuth {...footerauth} />
        </section>
      </main>
    </>
  );
};

export default Login;
